import { useState } from 'react'

import useViewGroups from '../useViewGroups/useViewGroups'

const useCreateViewDrawer = ({
  storeId,
  merchantId,
  selectedView,
  getFilters,
  createView,
  canShareViewsWithAllGroups,
}) => {
  const [pendingView, setPendingView] = useState(null)
  const { groups, ownGroupIds, fetchingUserGroups, loadGroups } = useViewGroups({
    storeId,
    merchantId,
    canShareViewsWithAllGroups,
  })

  const openDrawer = view => {
    setPendingView(view)
    loadGroups()
  }

  const openCreateViewDrawer = () => openDrawer({ name: '', filters: getFilters() })

  const openDuplicateViewDrawer = () => {
    openDrawer({ name: `${selectedView.name} (copy)`, filters: selectedView.filters })
  }

  const closeCreateViewDrawer = () => setPendingView(null)

  const handleCreateView = async ({ name, sharedWithGroups }) => {
    await createView({ name, filters: pendingView.filters, sharedWithGroups })
    setPendingView(null)
  }

  return {
    showCreateViewDrawer: Boolean(pendingView),
    initialViewName: pendingView?.name,
    groups,
    fixedGroupIds: ownGroupIds,
    fetchingUserGroups,
    openCreateViewDrawer,
    openDuplicateViewDrawer,
    closeCreateViewDrawer,
    handleCreateView,
  }
}

export default useCreateViewDrawer
